import type { LangCode } from '@learnforge/i18n';
import { en } from './en';
import { nl } from './nl';
import { ro } from './ro';
import type { GeometryKey } from './keys';

export const locales = {
  en,
  nl,
  ro,
} as const satisfies Partial<Record<LangCode, Record<GeometryKey, string>>> & {
  en: Record<GeometryKey, string>;
};
export type { GeometryKey } from './keys';
